// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"ed4dfe89","653":"61158419"}[chunkId] + ".chunk.js";
};